// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsPaymentWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  PreviewApplicationPaymentRequestDto,
  PreviewApplicationPaymentResponseDto,
  StartPaymentMethodSessionRequestDto,
  StartPaymentMethodSessionResponseDto,
  SubmitApplicationPaymentRequestDto,
  SubmitOrderResponseDto,
} from '../..';

export const CappsPaymentWebApiHandler_previewApplicationPayment_Path =
  '/api/web/renter/v1/payment/previewApplicationPayment';

export const CappsPaymentWebApiHandler_previewApplicationPayment = (
  postData: PreviewApplicationPaymentRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, PreviewApplicationPaymentRequestDto, PreviewApplicationPaymentResponseDto>(
    {
      endpoint: CappsPaymentWebApiHandler_previewApplicationPayment_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsPaymentWebApiHandler_startPaymentMethodSession_Path =
  '/api/web/renter/v1/payment/startPaymentMethodSession';

export const CappsPaymentWebApiHandler_startPaymentMethodSession = (
  postData: StartPaymentMethodSessionRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, StartPaymentMethodSessionRequestDto, StartPaymentMethodSessionResponseDto>(
    {
      endpoint: CappsPaymentWebApiHandler_startPaymentMethodSession_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsPaymentWebApiHandler_submitApplicationPayment_Path =
  '/api/web/renter/v1/payment/submitApplicationPayment';

export const CappsPaymentWebApiHandler_submitApplicationPayment = (
  postData: SubmitApplicationPaymentRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SubmitApplicationPaymentRequestDto, SubmitOrderResponseDto>(
    {
      endpoint: CappsPaymentWebApiHandler_submitApplicationPayment_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
